import { getConfigManager } from '../../config/getConfigManager';
import { Decimal } from '../../datastructures';
import poolsLPTokenTotalSupplyAtom from './poolsLPTokenTotalSupplyAtom';
import poolBalanceAtom from './poolBalanceAtom';
import { createAsyncAtom } from '../../lib/state';

const poolsShareAtom = createAsyncAtom(async get => {
  const poolTotalSupply = await get(poolsLPTokenTotalSupplyAtom);
  const poolBalance = await get(poolBalanceAtom);

  const pools = getConfigManager().getConfig().pools;

  const poolShare: { [pairId: string]: Decimal } = {};
  Object.entries(pools).map(([, pool]) => {
    const totalSupply = poolTotalSupply[pool.pair.id];
    const balance = poolBalance[pool.pair.id];

    if (totalSupply && balance) {
      if (totalSupply.isZero()) {
        poolShare[pool.pair.id] = new Decimal(0);
      } else {
        poolShare[pool.pair.id] = balance.div(totalSupply);
      }
    } else {
      poolShare[pool.pair.id] = new Decimal(0);
    }
  });

  return poolShare;
});
export default poolsShareAtom;
